import queryString from "query-string";

import {
    GET_ACTIVITY,
    GET_DASHBOARD_HR_DATA,
    GET_DASHBOARD_HR_DATA_ADOPTION,
    GET_DASHBOARD_MANAGER_DATA,
    GET_DASHBOARD_PERSONAL,
    GET_DASHBOARD_PERSONAL_DATA,
    GET_DASHBOARD_SUMMARY_PARTNER,
    GET_DASHBOARD_TIME_SERIES_PARTNER,
    GET_DASHBOARD_ROLE_COMPETENCIES_PARTNER,
    GET_DASHBOARD_SUMMARY_HSE,
    GET_DASHBOARD_TIME_SERIES_HSE,
    GET_DASHBOARD_ROLE_COMPETENCIES_HSE,
    GET_DASHBOARD_SUMMARY_SITE,
    GET_DASHBOARD_TIME_SERIES_SITE,
    GET_DASHBOARD_ROLE_COMPETENCIES_SITE,
    GET_DASHBOARD_SUMMARY_EMPLOYEE,
    GET_DASHBOARD_TIME_SERIES_EMPLOYEE,
    GET_DASHBOARD_DETAIL_EMPLOYEE,
    GET_DASHBOARD_SUMMARY_INTERNAL,
    GET_DASHBOARD_TIME_SERIES_INTERNAL,
    GET_DASHBOARD_ROLE_COMPETENCIES_INTERNAL,
    GET_DASHBOARD_COMPETENCIES_INTERNAL,
    GET_DASHBOARD_COMPANIES,
    GET_DASHBOARD_COMPANY_OPTIONS,
    EXPORT_DASHBOARD_REPORT,
    GET_DASHBOARD_COMPANY_EMPLOYEES,
} from "@/api/dashboard/dashboard";

const state = {
    dataDashboard: [],
    dataDashboardPersonalData: [],
    dataDashboardManagerData: [],
    dataDashboardHRData: [],
    dataDashboardHRAdoption: [],
    dataActivity: [],
    dashboardSummaryPartner: {
        totalPlanned: 0,
        totalActual: 0,
        achieved: 0
    },
    dashboardTimeSeriesPartner: {
        planned: [],
        completed: [],
        xLabel: []
    },
    dashboardRoleCompetenciesPartner: [],
    dashboardSummaryHSE: {
        totalPlanned: 0,
        totalActual: 0,
        achieved: 0
    },
    dashboardTimeSeriesHSE: {
        planned: [],
        completed: [],
        xLabel: []
    },
    dashboardRoleCompetenciesHSE: [],
    dashboardSummarySite: {
        totalPlanned: 0,
        totalActual: 0,
        achieved: 0
    },
    dashboardTimeSeriesSite: {
        planned: [],
        completed: [],
        xLabel: []
    },
    dashboardRoleCompetenciesSite: [],
    dashboardSummaryEmployee: {
        totalPlanned: 0,
        totalActual: 0,
        achieved: 0
    },
    dashboardTimeSeriesEmployee: {
        planned: [],
        completed: [],
        xLabel: []
    },
    dashboardDetailEmployee: {
        data: [],
        pagination: {
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 0
        }
    },
    dashboardSummaryInternal: {
        totalPlanned: 0,
        totalActual: 0,
        achieved: 0
    },
    dashboardTimeSeriesInternal: {
        planned: [],
        completed: [],
        xLabel: []
    },
    dashboardRoleCompetenciesInternal: [],
    dashboardCompetenciesInternal: [],
    dashboardCompanyOptions: [],
    dashboardCompanies: [],
    dashboardCompanyEmployees: {
        data: [],
        pagination: {
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 0
        }
    },
};

const mutations = {
    setDashboard: (states, payload) => {
        states.dataDashboard = payload;
    },
    setDashboardPersonalData: (states, payload) => {
        states.dataDashboardPersonalData = payload;
    },
    setDashboardManagerData: (states, payload) => {
        states.dataDashboardManagerData = payload;
    },
    setDashboardHRData: (states, payload) => {
        states.dataDashboardHRData = payload;
    },
    setDashboardHRAdoption: (states, payload) => {
        states.dataDashboardHRAdoption = payload;
    },
    setActivity: (states, payload) => {
        states.dataActivity = payload;

    },
    setDashboardSummaryPartner: (states, payload) => {
        states.dashboardSummaryPartner = payload;
    },
    setDashboardTimeSeriesPartner: (states, payload) => {
        states.dashboardTimeSeriesPartner = payload;
    },
    setDashboardRoleCompetenciesPartner: (states, payload) => {
        states.dashboardRoleCompetenciesPartner = payload;
    },
    setDashboardSummaryHSE: (states, payload) => {
        states.dashboardSummaryHSE = payload;
    },
    setDashboardTimeSeriesHSE: (states, payload) => {
        states.dashboardTimeSeriesHSE = payload;
    },
    setDashboardRoleCompetenciesHSE: (states, payload) => {
        states.dashboardRoleCompetenciesHSE = payload;
    },
    setDashboardSummarySite: (states, payload) => {
        states.dashboardSummarySite = payload;
    },
    setDashboardTimeSeriesSite: (states, payload) => {
        states.dashboardTimeSeriesSite = payload;
    },
    setDashboardRoleCompetenciesSite: (states, payload) => {
        states.dashboardRoleCompetenciesSite = payload;
    },
    setDashboardSummaryEmployee: (states, payload) => {
        states.dashboardSummaryEmployee = payload;
    },
    setDashboardTimeSeriesEmployee: (states, payload) => {
        states.dashboardTimeSeriesEmployee = payload;
    },
    setDashboardDetailEmployee: (states, payload) => {
        states.dashboardDetailEmployee = payload;
    },
    setDashboardSummaryInternal: (states, payload) => {
        states.dashboardSummaryInternal = payload;
    },
    setDashboardTimeSeriesInternal: (states, payload) => {
        states.dashboardTimeSeriesInternal = payload;
    },
    setDashboardRoleCompetenciesInternal: (states, payload) => {
        states.dashboardRoleCompetenciesInternal = payload;
    },
    setDashboardCompetenciesInternal: (states, payload) => {
        states.dashboardCompetenciesInternal = payload;
    },
    setDashboardCompanyOptions: (states, payload) => {
        states.dashboardCompanyOptions = payload;
    },
    setDashboardCompanies: (states, payload) => {
        states.dashboardCompanies = payload;
    },
    setDashboardCompanyEmployees: (states, payload) => {
        states.dashboardCompanyEmployees = payload;
    },
};

const actions = {
    getDashboardPersonal: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_DASHBOARD_PERSONAL(params);
            // console.log("resppp",resp)
            if (resp.data.httpCode === 200) {
                commit("setDashboard", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDashboard", []);
            }
            throw err; // Rethrow the error so it can be caught in the component
        }
    },
    getDashboardPersonalData: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_DASHBOARD_PERSONAL_DATA(params);
            // console.log("resppp",resp)
            if (resp.data.httpCode === 200) {
                commit("setDashboardPersonalData", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDashboardPersonalData", []);
            }
            throw err;
        }
    },
    getDashboardManagerData: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_DASHBOARD_MANAGER_DATA(params);
            // console.log("resppp",resp)
            if (resp.data.httpCode === 200) {
                commit("setDashboardManagerData", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDashboardManagerData", []);
            }
            throw err;
        }
    },
    getDashboardHRData: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_DASHBOARD_HR_DATA(args);
            // console.log("resppp",resp)
            if (resp.data.httpCode === 200) {
                commit("setDashboardHRData", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDashboardHRData", []);
            }
            throw err;
        }
    },
    getDashboardHRAdoption: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_DASHBOARD_HR_DATA_ADOPTION(args);
            // console.log("resppp",resp)
            if (resp.data.httpCode === 200) {
                commit("setDashboardHRAdoption", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDashboardHRAdoption", []);
            }
            throw err;
        }
    },

    getActivityLog: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_ACTIVITY(params);
            if (resp.data.httpCode === 200) {
                commit("setActivity", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setActivity", []);
            }
            throw err;
        }
    },

    getDashboardSummaryPartner: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_SUMMARY_PARTNER(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardSummaryPartner", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardSummaryPartner", {
                    totalPlanned: 0,
                    totalActual: 0,
                    achieved: 0
                });
            }
            throw err;
        }
    },

    getDashboardTimeSeriesPartner: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_TIME_SERIES_PARTNER(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardTimeSeriesPartner", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardTimeSeriesPartner", {
                    planned: [],
                    completed: [],
                    xLabel: []
                });
            }
            throw err;
        }
    },

    getDashboardRoleCompetenciesPartner: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_ROLE_COMPETENCIES_PARTNER(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardRoleCompetenciesPartner", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardRoleCompetenciesPartner", []);
            }
            throw err;
        }
    },

    getDashboardSummaryHSE: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_SUMMARY_HSE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardSummaryHSE", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardSummaryHSE", {
                    totalPlanned: 0,
                    totalActual: 0,
                    achieved: 0
                });
            }
            throw err;
        }
    },

    getDashboardTimeSeriesHSE: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_TIME_SERIES_HSE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardTimeSeriesHSE", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardTimeSeriesHSE", {
                    planned: [],
                    completed: [],
                    xLabel: []
                });
            }
            throw err;
        }
    },

    getDashboardRoleCompetenciesHSE: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_ROLE_COMPETENCIES_HSE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardRoleCompetenciesHSE", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardRoleCompetenciesHSE", []);
            }
            throw err;
        }
    },

    getDashboardSummarySite: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_SUMMARY_SITE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardSummarySite", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardSummarySite", {
                    totalPlanned: 0,
                    totalActual: 0,
                    achieved: 0
                });
            }
            throw err;
        }
    },

    getDashboardTimeSeriesSite: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_TIME_SERIES_SITE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardTimeSeriesSite", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardTimeSeriesSite", {
                    planned: [],
                    completed: [],
                    xLabel: []
                });
            }
            throw err;
        }
    },

    getDashboardRoleCompetenciesSite: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_ROLE_COMPETENCIES_SITE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardRoleCompetenciesSite", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardRoleCompetenciesSite", []);
            }
            throw err;
        }
    },

    getDashboardSummaryEmployee: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_SUMMARY_EMPLOYEE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardSummaryEmployee", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardSummaryEmployee", {
                    totalPlanned: 0,
                    totalActual: 0,
                    achieved: 0
                });
            }
            throw err;
        }
    },

    getDashboardTimeSeriesEmployee: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_TIME_SERIES_EMPLOYEE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardTimeSeriesEmployee", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardTimeSeriesEmployee", {
                    planned: [],
                    completed: [],
                    xLabel: []
                });
            }
            throw err;
        }
    },

    getDashboardDetailEmployee: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_DETAIL_EMPLOYEE(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardDetailEmployee", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardDetailEmployee", {
                    data: [],
                    pagination: {
                        page: 1,
                        limit: 10,
                        total: 0,
                        totalPages: 0
                    }
                });
            }
            throw err;
        }
    },

    getDashboardSummaryInternal: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_SUMMARY_INTERNAL(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardSummaryInternal", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardSummaryInternal", {
                    totalPlanned: 0,
                    totalActual: 0,
                    achieved: 0
                });
            }
            throw err;
        }
    },

    getDashboardTimeSeriesInternal: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_TIME_SERIES_INTERNAL(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardTimeSeriesInternal", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardTimeSeriesInternal", {
                    planned: [],
                    completed: [],
                    xLabel: []
                });
            }
            throw err;
        }
    },

    getDashboardRoleCompetenciesInternal: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_ROLE_COMPETENCIES_INTERNAL(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardRoleCompetenciesInternal", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardRoleCompetenciesInternal", []);
            }
            throw err;
        }
    },

    // Export Report Action
    exportDashboardReport: async ({ commit }, payload) => {
        try {
            const resp = await EXPORT_DASHBOARD_REPORT(payload);
            return resp;
        } catch (err) {
            console.error("Error exporting report:", err);
            throw err;
        }
    },

    getDashboardCompetenciesInternal: async ({ commit }, params) => {
        try {
            const resp = await GET_DASHBOARD_COMPETENCIES_INTERNAL(params);
            if (resp.data.httpCode === 200) {
                commit("setDashboardCompetenciesInternal", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardCompetenciesInternal", []);
            }
            throw err;
        }
    },
    getDashboardCompanies: async ({ commit }, args) => {
        try {
            const resp = await GET_DASHBOARD_COMPANIES(args);
            if (resp.data.httpCode === 200) {
                commit("setDashboardCompanies", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardCompanies", []);
            }
            throw err;
        }
    },
    getDashboardCompanyOptions: async ({ commit }, args) => {
        try {
            const resp = await GET_DASHBOARD_COMPANY_OPTIONS(args);
            if (resp.data.httpCode === 200) {
                commit("setDashboardCompanyOptions", resp.data.data || []);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardCompanyOptions", []);
            }
            throw err;
        }
    },
    getDashboardCompanyEmployees: async ({ commit }, args) => {
        try {
            const resp = await GET_DASHBOARD_COMPANY_EMPLOYEES(args);
            if (resp.data.httpCode === 200) {
                commit("setDashboardCompanyEmployees", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setDashboardCompanyEmployees", {
                    data: [],
                    pagination: {
                        page: 1,
                        limit: 10,
                        total: 0,
                        totalPages: 0
                    }
                });
            }
            throw err;
        }
    }


};

const getters = {
    DashboardData: (states) => states.dataDashboard,
    personalDashboard: (states) => states.dataDashboardPersonalData,
    ManagerDashboard: (states) => states.dataDashboardManagerData,
    hrDashboard: (states) => states.dataDashboardHRData,
    hrAdoption: (states) => states.dataDashboardHRAdoption,
    activity: (states) => states.dataActivity,
    dashboardSummaryPartner: (states) => states.dashboardSummaryPartner,
    dashboardTimeSeriesPartner: (states) => states.dashboardTimeSeriesPartner,
    dashboardRoleCompetenciesPartner: (states) => states.dashboardRoleCompetenciesPartner,
    dashboardSummaryHSE: (states) => states.dashboardSummaryHSE,
    dashboardTimeSeriesHSE: (states) => states.dashboardTimeSeriesHSE,
    dashboardRoleCompetenciesHSE: (states) => states.dashboardRoleCompetenciesHSE,
    dashboardSummarySite: (states) => states.dashboardSummarySite,
    dashboardTimeSeriesSite: (states) => states.dashboardTimeSeriesSite,
    dashboardRoleCompetenciesSite: (states) => states.dashboardRoleCompetenciesSite,
    dashboardSummaryEmployee: (states) => states.dashboardSummaryEmployee,
    dashboardTimeSeriesEmployee: (states) => states.dashboardTimeSeriesEmployee,
    dashboardDetailEmployee: (states) => states.dashboardDetailEmployee,
    dashboardSummaryInternal: (states) => states.dashboardSummaryInternal,
    dashboardTimeSeriesInternal: (states) => states.dashboardTimeSeriesInternal,
    dashboardRoleCompetenciesInternal: (states) => states.dashboardRoleCompetenciesInternal,
    dashboardCompetenciesInternal: (states) => states.dashboardCompetenciesInternal,
    dashboardCompanyOptions: (states) => states.dashboardCompanyOptions,
    dashboardCompanies: (states) => states.dashboardCompanies,
    dashboardCompanyEmployees: (states) => states.dashboardCompanyEmployees,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
